import React, { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { UserContext } from '../../../context/UserContext';
import client from '../../../lib/client';
import { editUserMutation } from '../../../queries/user';
import { EditUserMutation, EditUserMutationVariables } from '../../../queries/__generated__/EditUserMutation';
import { Input } from '../../forms';
import { Button, Card, CardSegment } from '../../ui';

const UserProfile: React.FC = () => {
  const { user } = useContext(UserContext);
  const [name, setName] = useState(user.displayName);
  const [email, setEmail] = useState(user.email);

  async function saveUser() {
    await client.mutate<EditUserMutation, EditUserMutationVariables>({
      mutation: editUserMutation,
      variables: {
        input: {
          userId: user.id,
          displayName: name,
          email
        }
      }
    });

    toast('Profile updated!', { type: 'success' });
  }

  return (
    <Card className="mb2">
      <CardSegment className="pa4">
        <h3 className="f5 fw6 mt0 mb3">Profile</h3>
        <Input
          label="Display Name"
          className="mb3"
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder="Your name..."
        />

        <Input
          label="email"
          className="mb3"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="Your email..."
        />

        <Button onClick={saveUser}>Save</Button>
      </CardSegment>
    </Card>
  );
};

export default UserProfile;
